import "./globals.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

function MyApp({ Component, pageProps }) {
  const [queryClient] = useState(() => new QueryClient());

  useEffect(() => {
    document
      .querySelectorAll("style[data-next-hide-fouc]")
      .forEach((element) => element.parentNode?.removeChild(element));
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Component {...pageProps} />
    </QueryClientProvider>
  );
}

export default MyApp;
